import { getImageUrl } from '@flecto/utils'

import { useStoreDetails } from './useStoreDetails'

export function useStoreBackground() {
  const store = useStoreDetails()

  return store?.bg_image_url ? getImageUrl(store?.bg_image_url) : null
}
